export const BRAND = {
  name: "Pistone Parla Chiaro",
  claim: "Tu segnali. Noi pensiamo al resto.",
};

// Commission state meta (wallet)
export const COMMISSION_STATE_META = {
  potenziale: { label: "Potenziale", color: "text-amber-600", bg: "bg-amber-50", ring: "ring-amber-200" },
  maturato: { label: "Maturato", color: "text-emerald-600", bg: "bg-emerald-50", ring: "ring-emerald-200" },
  in_pagamento: { label: "In pagamento", color: "text-blue-600", bg: "bg-blue-50", ring: "ring-blue-200" },
  pagato: { label: "Pagato", color: "text-[#0A1128]", bg: "bg-[#D4AF37]/15", ring: "ring-[#D4AF37]/40" },
};

// Status badge colors (admin)
export const STATUS_COLORS = {
  NUOVA_SEGNALAZIONE: "bg-slate-100 text-slate-700",
  CONTATTATO: "bg-blue-100 text-blue-700",
  NON_INTERESSATO: "bg-rose-100 text-rose-700",
  DA_RICONTATTARE: "bg-amber-100 text-amber-700",
  VALUTAZIONE_PROGRAMMATA: "bg-indigo-100 text-indigo-700",
  VALUTAZIONE_EFFETTUATA: "bg-indigo-100 text-indigo-700",
  INCARICO_ACQUISITO: "bg-emerald-100 text-emerald-700",
  IMMOBILE_PUBBLICATO: "bg-cyan-100 text-cyan-700",
  VISITE_IN_CORSO: "bg-cyan-100 text-cyan-700",
  PROPOSTA_RICEVUTA: "bg-violet-100 text-violet-700",
  PROPOSTA_ACCETTATA: "bg-violet-100 text-violet-700",
  AFFARE_CONCLUSO: "bg-emerald-100 text-emerald-800",
  COMPENSO_MATURATO: "bg-[#D4AF37]/20 text-[#8a6d0f]",
  PAGAMENTO_PROGRAMMATO: "bg-[#D4AF37]/20 text-[#8a6d0f]",
  PAGATO: "bg-[#D4AF37]/30 text-[#8a6d0f]",
  SEGNALAZIONE_CHIUSA: "bg-slate-200 text-slate-600",
};

export function eur(n) {
  if (n == null || n === "") return "€ —";
  const v = Number(n);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(isNaN(v) ? 0 : v);
}

export const DOC_STATUSES = [
  { key: "RICHIESTO", label: "Richiesto" },
  { key: "CARICATO", label: "Caricato" },
  { key: "IN_VERIFICA", label: "In verifica" },
  { key: "VERIFICATO", label: "Verificato" },
];

export const DOC_STATUS_COLORS = {
  RICHIESTO: "bg-amber-100 text-amber-700",
  CARICATO: "bg-blue-100 text-blue-700",
  IN_VERIFICA: "bg-indigo-100 text-indigo-700",
  VERIFICATO: "bg-emerald-100 text-emerald-700",
};
